import { render, staticRenderFns } from "./RecallDialog.vue?vue&type=template&id=1034b217&scoped=true"
import script from "./RecallDialog.vue?vue&type=script&lang=js"
export * from "./RecallDialog.vue?vue&type=script&lang=js"
import style0 from "./RecallDialog.vue?vue&type=style&index=0&id=1034b217&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034b217",
  null
  
)

export default component.exports